// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.promoRow[data-v-044ef07c] {\n  height: 60px;\n}\n", ""]);
// Exports
module.exports = exports;
